export const HOME = '/home'
export const AUTH = '/auth'
export const RESEARCH = '/research'

export const ASSETLIST = '/asset-list'
// export const ADDASSET = '/asset-detail'
export const MAPPHOTOS = '/map-photos'
export const FINDREPLACE = '/findreplace'

export const LINELIST = '/line-list'
export const ADDLINE = '/line-detail'

export const ASSETREPORTLIST = '/asset-list-reports'
export const REPORTVALUATION = '/valuation-reports'
export const PHOTOREPORTS = '/other-reports'

export const IMPORTASSET = '/import'
export const FINDREPLACEIMPORTEDASSET = '/findreplace-imported-asset'
export const FIELDMAPPING = '/field-mapping'

export const ASSIGNAPPRAISER = '/assign-appraiser'
export const MANAGEASSETCLASS = '/asset-class'
export const MANAGEAREA = '/manage-area'
export const MANAGESERAILLABELS = '/manage-serial-labels'
export const MANAGEASSETTYPE = '/manage-asset-type'
export const MANAGEMAKE = '/manage-make'
export const MANAGEMODEL = '/manage-model'
export const MANAGEUSER = '/manage-user'
export const VALIDATEMODEL = '/validate-model'

